export default __webpack_public_path__ + "static/media/beefy-cropped.189b3169.svg";